import React, { useEffect, useState } from "react";
import { Alert, Spinner, Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation } from "react-router-dom";
import UlpsPortalApiClient from "../UlpsPortalApiClient";

export default function FeatureGroups() {
  const [featureGroups, setFeatureGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("success") === "true") {
      setSuccessMessage("Feature group saved successfully.");

      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [location.search]);

  useEffect(() => {
    setLoading(true);

    UlpsPortalApiClient.getFeatureGroups()
      .then((data) => {
        setFeatureGroups(data || []);
      })
      .catch((e) => {
        console.error(e);
        setError("Failed to load feature groups.");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleDelete = (featureGroupId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this feature group?"
    );

    if (!confirmed) return;

    UlpsPortalApiClient.deleteFeatureGroup(featureGroupId)
      .then(() => {
        setFeatureGroups((prev) => prev.filter((group) => group.id !== featureGroupId));
        setSuccessMessage("Feature group deleted successfully.");
        setTimeout(() => setSuccessMessage(""), 4000);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to delete feature group.");
      });
  };

  const columns = [
    {
      dataField: "id",
      text: "ID",
      headerStyle: { width: "80px" },
      sort: true,
    },
    {
      dataField: "name",
      text: "Group Name",
      sort: true,
    },
    {
      dataField: "licenceSchema",
      text: "Product",
      sort: true,
    },
    {
      dataField: "features",
      text: "Features",
      formatter: (_, row) =>
        row.features && row.features.length > 0
          ? row.features.map((feature) => feature.description || feature.name).join(", ")
          : "None",
    },
    {
      dataField: "actions",
      text: "",
      headerStyle: { width: "140px" },
      formatter: (_, row) => (
        <>
          <Button
            variant="primary"
            size="sm"
            className="mr-2"
            href={`#/feature-groups/edit?id=${row.id}`}
          >
            Edit
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => handleDelete(row.id)}
          >
            X
          </Button>
        </>
      ),
    },
  ];

  return (
    <>
      <h2>ULPS Feature Groups</h2>

      {successMessage && (
        <Alert
          variant="success"
          dismissible
          onClose={() => setSuccessMessage("")}
        >
          {successMessage}
        </Alert>
      )}

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError("")}>
          {error}
        </Alert>
      )}

      <Button
        className="mb-3"
        variant="success"
        href="#/feature-groups/create"
      >
        Add Feature Group
      </Button>

      {loading ? (
        <div className="d-flex justify-content-center mb-3">
          <Spinner animation="border" />
        </div>
      ) : (
        <BootstrapTable
          keyField="id"
          data={featureGroups}
          columns={columns}
          striped
          hover
          condensed
          noDataIndication="No feature groups found"
        />
      )}
    </>
  );
}
